module.exports = __webpack_public_path__ + "footer-icon-cg.png?7fb4cc7cba73d2d1c871af3d5b741eae";


//////////////////
// WEBPACK FOOTER
// ./src/Footer/img/base64/footer-icon-cg.png
// module id = 17
// module chunks = 0